/* eslint-disable react-hooks/exhaustive-deps */
import { BoxColumnWrapper, BoxOutline } from "styles/common/BoxStyle";
import { CommonWrapper } from "styles/common/Layout";
import { Row, RowWithArrow } from "styles/common/NavigationStyle";
import { getSetting } from "api/setting";
import useAuthStore from "store/auth";
import { Line } from "styles/common/FormStyle";
import { TextBlack, TextPrimary } from "styles/common/TextStyle";
import { API_URL } from "utils/constants";
import { useEffect, useState } from "react";
import useModalStore from "store/modal";

const Setting = () => {
  const authStore = useAuthStore();
  const user = authStore?.user;
  const [appVersion, setAppVersion] = useState("");
  const openModal = useModalStore((state) => state.openModal);

  useEffect(() => {
    setAppVersion("1.0.0");
    // window.updatetextonwebview = (text) => {
    //   if (!text.includes("VERSION")) {
    //     return;
    //   }

    //   const version = text.split("=")[1];
    //   setAppVersion(version);
    // };

    // window.updatetextonwebview("VERSION=1.0.0");
    fetchSettingValue();
  }, []);

  const fetchSettingValue = async () => {
    try {
      const res = await getSetting();
      user.pushnotice = res?.data?.result?.pushnotice;
      user.pushmarketing = res?.data?.result?.pushmarketing;
      authStore.setUser(user);
    } catch (err) {
      alert(err);
    }
  }
  
  return (
    <CommonWrapper>
      <BoxOutline margin="20px 0 0 0">
        {/* <Row>
          <BoxColumnWrapper>
            <div>공지 알림</div>
            <SwitchInput
              type="checkbox"
              checked={user?.pushnotice}
              onChange={toggleNotice}
            />
          </BoxColumnWrapper>
        </Row> */}
        {/* <Row> */}
          {/* <div>혜택 알림</div> */}
          {/* <Switch /> */}
          {/* <SwitchInput
            type="checkbox"
            checked={user?.pushmarketing}
            onChange={toggleMarketing}
          />
        </Row> */}
        {/* <Line /> */}
        <Row cursor="default">
          <TextPrimary size="14px" weight="700">
            서비스 약관
          </TextPrimary>
        </Row>
        <RowWithArrow onClick={() => openModal({ content: API_URL.TERMS_URL })}>
          이용 약관
        </RowWithArrow>
        <RowWithArrow
          onClick={() => openModal({ content: API_URL.PRIVACY_URL })}
        >
          개인정보 처리방침
        </RowWithArrow>
        <Line />
        <Row cursor="default">
          <TextPrimary size="14px" weight="700">
            소프트웨어
          </TextPrimary>
        </Row>
        <Row disabled>
          <BoxColumnWrapper>
            <TextBlack>앱 버전</TextBlack>
            <TextBlack weight="600">{appVersion}</TextBlack>
          </BoxColumnWrapper>
        </Row>
      </BoxOutline>
    </CommonWrapper>
  );
};

export default Setting;
